import { render, staticRenderFns } from "./ResetPasswordRight.vue?vue&type=template&id=6802dedb"
import script from "./ResetPasswordRight.vue?vue&type=script&lang=js"
export * from "./ResetPasswordRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports